import { MyAppointmentsAsHealerDTO } from '../../infra/adapters/luminara/booking/dto/my-appointments-as-healer.dto';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface HealerSessionsState {
  showLoader: boolean;
  healerSessions?: MyAppointmentsAsHealerDTO;
  loadingDataError?: string;
}

export const initialHealerSessionsState = () =>
  ({
    showLoader: true,
    healerSessions: undefined,
    loadingDataError: undefined,
  } as HealerSessionsState);

export interface HealerSessionsAction {
  type:
    | 'LOAD_HEALER_SESSIONS_SUCCESS'
    | 'LOAD_HEALER_SESSIONS_FAILURE'
    | 'SESSION_CANCELLED_BY_HEALER_SUCCESS'
    | 'SESSION_CANCELLED_BY_HEALER_FAILURE'
    | 'HEALER_LOGGED_OUT';
  payload?: any;
}

const healerSessionsReducer = (state: HealerSessionsState = initialHealerSessionsState(), action: HealerSessionsAction): HealerSessionsState => {
  switch (action.type) {
    case 'LOAD_HEALER_SESSIONS_SUCCESS':
      return {
        ...state,
        showLoader: false,
        healerSessions: action.payload,
      };
    case 'LOAD_HEALER_SESSIONS_FAILURE':
      return { ...state, showLoader: false, loadingDataError: extractMessageFromError(action.payload) };
    case 'SESSION_CANCELLED_BY_HEALER_FAILURE': {
      return { ...state, loadingDataError: extractMessageFromError(action.payload) };
    }
    case 'SESSION_CANCELLED_BY_HEALER_SUCCESS': {
      return state;
    }
    case 'HEALER_LOGGED_OUT': {
      return initialHealerSessionsState();
    }
    default:
      return state;
  }
};

export default healerSessionsReducer;
